const LEGACY_SORT_VALUE_MAP = {
  created: "publication_date",
  "-created": "-publication_date",
  "stock__ticker,-created": "stock__ticker,-publication_date",
  "-stock__ticker,-created": "-stock__ticker,-publication_date",
  "stock__market,-created": "stock__market,-publication_date",
  "-stock__market,-created": "-stock__market,-publication_date"
};

const migrateAnalysisSortValue = sort => {
  if (typeof sort !== "string") {
    return sort;
  }

  return LEGACY_SORT_VALUE_MAP[sort] ?? sort;
};

export default migrateAnalysisSortValue;
